export default __webpack_public_path__ + "static/media/icon-document.873693f7.svg";